var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "v-app-bar",
        {
          staticClass: "header",
          attrs: { light: "", color: "white", flat: "" },
        },
        [
          this.$route.path !== "/"
            ? _c(
                "v-btn",
                {
                  staticClass: "header-back",
                  attrs: { depressed: "", text: "", "x-small": "" },
                  on: { click: _vm.goBack },
                },
                [_c("v-icon", [_vm._v("mdi-keyboard-backspace")])],
                1
              )
            : _vm._e(),
          _c(
            "v-toolbar-title",
            { staticClass: "header__logo pl-0" },
            [
              _c("router-link", { attrs: { to: "/" } }, [
                _vm._v("VGP JSC "),
                _c("span", [_vm._v("Giftcode")]),
              ]),
            ],
            1
          ),
          _c("v-spacer"),
          !_vm.isAuthenticated
            ? _c(
                "router-link",
                { staticClass: "header-logout__text", attrs: { to: "/login" } },
                [_vm._v(" Đăng nhập ")]
              )
            : _vm._e(),
          _vm.isAuthenticated
            ? _c("div", { staticClass: "header-login" }, [
                _vm._v(" " + _vm._s(_vm.username) + " "),
              ])
            : _vm._e(),
          _c(
            "v-menu",
            {
              staticClass: "header-logout__menu",
              attrs: { "offset-y": "" },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function (ref) {
                    var on = ref.on
                    var attrs = ref.attrs
                    return [
                      _c(
                        "v-btn",
                        _vm._g(
                          _vm._b(
                            {
                              staticClass: "header-logout__btn",
                              attrs: {
                                fab: "",
                                depressed: "",
                                dark: "",
                                small: "",
                                color: "primary",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.support()
                                },
                              },
                            },
                            "v-btn",
                            attrs,
                            false
                          ),
                          on
                        ),
                        [
                          _c("img", {
                            attrs: {
                              src: require("../assets/icons/user.svg"),
                              alt: "",
                            },
                          }),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "v-list",
                {
                  staticClass: "header-logout__dropdown",
                  class: { activeSupport: _vm.activeClass },
                  attrs: { outlined: "" },
                },
                [
                  _vm.isAuthenticated
                    ? _c(
                        "v-list-item",
                        {
                          staticClass: "header-logout__menu logout",
                          attrs: { outlined: "" },
                        },
                        [
                          _c(
                            "v-list-item-title",
                            {
                              staticClass: "header-logout__menu--title",
                              attrs: { outlined: "" },
                            },
                            [
                              _c("router-link", { attrs: { to: "/login" } }, [
                                _c(
                                  "div",
                                  {
                                    on: {
                                      click: function ($event) {
                                        ;(_vm.overlay = false), _vm.logout()
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(" Đăng xuất "),
                                    _c("img", {
                                      staticClass: "header-logout__icon",
                                      attrs: {
                                        src: require("../assets/icons/logout.svg"),
                                        alt: "",
                                        srcset: "",
                                      },
                                    }),
                                  ]
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "v-list-item",
                    {
                      staticClass: "header-logout__menu sp",
                      attrs: { outlined: "" },
                    },
                    [
                      _c(
                        "v-list-item-title",
                        {
                          staticClass: "header-logout__menu--title",
                          attrs: { outlined: "" },
                        },
                        [
                          _c("router-link", { attrs: { to: "/support" } }, [
                            _c(
                              "div",
                              {
                                on: {
                                  click: function ($event) {
                                    _vm.overlay = false
                                  },
                                },
                              },
                              [
                                _vm._v(" Hỗ trợ "),
                                _c("img", {
                                  staticClass: "header-logout__icon",
                                  attrs: {
                                    src: require("../assets/icons/support.svg"),
                                    alt: "",
                                    srcset: "",
                                  },
                                }),
                              ]
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-list-item",
                    {
                      staticClass: "header-logout__menu fix",
                      attrs: { outlined: "" },
                    },
                    [
                      _c(
                        "v-list-item-title",
                        {
                          staticClass: "header-logout__menu--title",
                          attrs: { outlined: "" },
                        },
                        [
                          _c("router-link", { attrs: { to: "" } }, [
                            _c(
                              "div",
                              {
                                on: {
                                  click: function ($event) {
                                    ;(_vm.overlay = false), _vm.clearCache()
                                  },
                                },
                              },
                              [
                                _vm._v(" Sửa lỗi "),
                                _c(
                                  "v-icon",
                                  {
                                    staticClass:
                                      "header-logout__menu fix--icon",
                                  },
                                  [_vm._v("mdi-reload")]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("v-overlay", {
        attrs: { color: "#fff", opacity: "0.97", value: _vm.overlay },
      }),
      !_vm.isAuthenticated &&
      this.$route.path !== "/login" &&
      this.$route.path !== "/" &&
      _vm.loginRequired === true
        ? _c(
            "v-dialog",
            {
              attrs: {
                persistent: "",
                "overlay-opacity": "0.97",
                "overlay-color": "#fff",
                "max-width": "290",
              },
              model: {
                value: _vm.dialogLogin,
                callback: function ($$v) {
                  _vm.dialogLogin = $$v
                },
                expression: "dialogLogin",
              },
            },
            [
              _c(
                "v-card",
                { staticClass: "dialog-login" },
                [
                  _c(
                    "v-card-title",
                    {
                      staticClass:
                        "dialog-login__title headline justify-center",
                    },
                    [_vm._v(" Thông báo ")]
                  ),
                  _c("v-card-text", { staticClass: "text-center" }, [
                    _vm._v(
                      "Vui lòng Đăng nhập để trải nghiệm các giftcode hấp dẫn dành riêng cho bạn."
                    ),
                  ]),
                  _c(
                    "v-card-actions",
                    { staticClass: "justify-center" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass:
                            "dialog-login__btn white--text text-none",
                          attrs: {
                            color: "#e88d50",
                            outlined: "",
                            height: "50px",
                          },
                          on: { click: _vm.loggedIn },
                        },
                        [_vm._v(" Đăng nhập VGPID ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }